angular.module('property', ['core', 'project', 'property.import', 'property-deal'])
    .component('propertyStatusLabel', {
        bindings: {
            status: '<'
        },
        template: '<span class="label label-default property-status {{$ctrl.status}}">{{ \'property.status.\'.concat($ctrl.status) | translate }}</span>'
    })
    .component('propertyStatusLabelWithDate', {
        bindings: {
            status: '<',
            propertyDealId: '<'
        },
        template: '<span class="label label-default property-status {{$ctrl.status}}" ng-mouseenter="$ctrl.loadAgreements()">{{ \'property.status.\'.concat($ctrl.status) | translate }}</span>' +
            '<div ng-if="$ctrl.agreement" style="white-space: nowrap;" uib-tooltip="{{ \'property-deal.agreement-type.\' + $ctrl.agreement.agreementType | translate }}">{{$ctrl.agreement.agreementDate}}</div>' +
            '<div ng-if="$ctrl.isLoading"><i class="fa fa-spinner fa-spin"></i></div>',
        controller: function (PropertyDeal) {
            this.loadAgreements = () => {
                if (!this.propertyDealId || this.agreement)
                    return

                this.isLoading = true
                PropertyDeal.lastImportantAgreement({id: this.propertyDealId}).$promise
                    .then(result => this.agreement = result)
                    .finally(() => this.isLoading = false)
            }
        }
    })
    .component('propertyAttributesSubTable', {
        bindings: {
            attributes: '<'
        },
        templateUrl: 'app/property/_attributes-table.html',
    })
    .component('propertyExtraChargesSubTable', {
        bindings: {
            extraCharges: '<'
        },
        templateUrl: 'app/property/_extra-charges-table.html',
    })
    .component('propertyPricingSummary', {
        bindings: {
            panelClass: '<',
            priceM2Net: '<',
            priceM2Gross: '<',
            totalNet: '<',
            totalGross: '<'
        },
        templateUrl: 'app/property/_pricing-summary.html',
    })
    .component('propertyWindowSide', {
        bindings: {
            side: '<'
        },
        template: '<span ng-if="$ctrl.side">{{ \'property.windowSide.\'+$ctrl.side | translate }}</span>'
    })
    .component('propertyArea', {
        bindings: {
            area: '<',
            areaFinal: '<',
            showWarning: '<',
            showBoth: '<'
        },
        templateUrl: 'app/property/_area.html',
        controller: function () {
            this.livingAreaConfirmationRequiredThreshold = 2.0

            this.$onInit = () => {
                this.diffPercent = Math.abs(this.areaFinal - this.area) / this.area * 100 || 0
            }
        }
    })
    .component('propertyPriceCalculation', {
        bindings: {
            calculationMethod: '<',
            calculationBasedOn: '<'
        },
        templateUrl: 'app/property/_price-calculation.html'
    })
    .component('propertyFloor', {
        bindings: {
            floor: '<',
            buildingFloors: '<'
        },
        template: '<span ng-if="$ctrl.floor != undefined">{{$ctrl.floor}}<span ng-if="$ctrl.buildingFloors != undefined">/{{$ctrl.buildingFloors}}</span></span>'
    })
    .factory('Property', function ($resource) {
        return $resource('/crm/api/property/:id/:action', {id: "@id", action: "@action"}, {
            get: {method: 'GET'},
            table: {method: 'GET', isArray: false, url: '/crm/api/property/table'},
            basicTable: {method: 'GET', isArray: false, url: '/crm/api/property/basic-table'},
            tableStatistics: {method: 'GET', isArray: false, url: '/crm/api/property/table-statistics'},
            statistics: {method: 'GET', isArray: true, url: '/crm/api/property-statistics'},
            update: {method: 'PUT'},
            remove: {method: 'DELETE'},
            techTypes: {method: 'GET', url: '/crm/api/property-tech-type', isArray: true},
            types: {method: 'GET', url: '/crm/api/property-type', isArray: true},
            attributes: {method: 'GET', url: '/crm/api/property-attribute', isArray: true},
            pricingStrategies: {method: 'GET', url: '/crm/api/property-pricing-strategy', isArray: true},
            statuses: {method: 'GET', url: '/crm/api/property-status', isArray: true},
            windowSides: {method: 'GET', url: '/crm/api/property-window-side', isArray: true},
            calculationMethods: {method: 'GET', url: '/crm/api/property-calculation-method', isArray: true},
            action: {method: 'POST'},
            additionalRequiredProperties: {method: 'GET', isArray: true, url: '/crm/api/property/:id/additional-required-properties'},
        });
    })
    .service('PropertyService', function ($http, $rootScope, toastr, modals, Property, Principal, FilesSimpleUploadService) {
        this.attributeTypes = () => {
            return [ 'ATTRIBUTE', 'EXTRA_CHARGE' ]
        }
        this.show = id => {
            Property.get({id: id}).$promise.then(item => {
                return modals.open('app/property/show-modal.html', 'PropertyShowController', item, {size: "lg"}, "$ctrl");
            });
        }
        this.edit = id => {
            Property.get({id: id}).$promise.then(item => edit_modal(item));
        }
        this.add = property => {
            let entity = {
                id: null,
                status: "AVAILABLE",
                attributes: [],
                extraCharges: []
            };
            angular.extend(entity, property);
            return edit_modal(entity);
        }
        this.selectProperty = (projectId, alreadySelectedPropertyIds, multiple = false) => {
            return modals.open('app/property/select-modal.html', 'PropertySelectController', {projectId: projectId, alreadySelectedPropertyIds: alreadySelectedPropertyIds, status: "AVAILABLE", multiple: multiple}, {size: "lg"}, "$ctrl");
        }
        this.selectPropertyBasic = (projectId, alreadySelectedPropertyIds = []) => {
            return modals.open('app/property/select-basic-modal.html', 'PropertySelectController', {table: "BASIC", projectId: projectId, alreadySelectedPropertyIds: alreadySelectedPropertyIds}, {size: "lg"}, "$ctrl");
        }
        this.delete = item => {
            return modals.confirmDelete("wybrany rekord", () => Property.delete({id: item.id}, () => $rootScope.$broadcast('property.updated')));
        }
        this.toggleLock = item => {
            return modals.open('app/property/lock-modal.html', 'PropertyLockController', item, {size: "sm"}, "$ctrl");
        }
        this.notesEdit = item => {
            return modals.open('app/property/notes-modal.html', 'PropertyNotesController', item, {size: "sm"}, "$ctrl");
        }
        this.batchFileUpload = () => {
            return modals.open('app/property/batch-upload-modal.html', 'PropertyBatchUploadController', null, {size: "sm"}, "$ctrl");
        }
        this.batchFileUploadComponent = () => {
            let filters = [{
                name: 'Filtr PDF',
                fn: function(item /*{File|FileLikeObject}*/, options) {
                    var type = '|' + item.type.slice(item.type.lastIndexOf('/') + 1) + '|';
                    return '|pdf|'.indexOf(type) !== -1;
                }
            }]
            return FilesSimpleUploadService.openCustom({url: "/crm/api/file-association-property/batch-upload", settings: {filters: filters, multiple: true}}).then(() => $rootScope.$broadcast("property.updated"))
        }
        this.modifyAssetGroups = property => modals.open('app/property/asset-groups-modal.html', 'PropertyAssetGroupController', {property: property}, {size: "sm"}, "$ctrl")
        this.modifyAdditionalAssetGroups = property => modals.open('app/property/asset-groups-modal.html', 'PropertyAdditionalAssetGroupsController', {property: property}, {size: "sm"}, "$ctrl")
        this.modifyAdditionalRequiredAssetGroups = property => modals.open('app/property/asset-groups-required-modal.html', 'PropertyAdditionalRequiredAssetGroupsController', {property: property}, {size: "sm"}, "$ctrl")

        function edit_modal(entity) {
            return modals.open('app/property/edit-modal.html', 'PropertyDialogController', entity, {size: "lg"}, "$ctrl");
        }

        this.recalculatePricingOfExtraCharge = (item) => {
            switch (item.calculationMethod) {
                case 'M2':
                case 'TOTAL':
                    delete item.pricing.pricePerOneNet
                    delete item.pricing.pricePerOneGross
                    item.pricing.totalGross = this.calculateGross(item.pricing.totalNet, item.vat);
                    break;
                case 'M2_GROSS':
                case 'TOTAL_GROSS':
                    delete item.pricing.pricePerOneNet
                    delete item.pricing.pricePerOneGross
                    item.pricing.totalNet = this.calculateNet(item.pricing.totalGross, item.vat);
                    break;
            }
        }
        this.recalculatePricingOfAttribute = (item) => {
            switch (item.calculationMethod) {
                case 'M2':
                case 'TOTAL':
                    item.attributes.filter(attr => attr.pricing?.totalNet !== undefined)
                        .forEach(attr => attr.pricing.totalGross = this.calculateGross(attr.pricing.totalNet, item.vat));
                    item.extraCharges?.filter(attr => attr.pricing?.totalNet !== undefined)
                        .forEach(attr => attr.pricing.totalGross = this.calculateGross(attr.pricing.totalNet, attr.vat));
                    break;
                case 'M2_GROSS':
                case 'TOTAL_GROSS':
                    item.attributes.filter(attr => attr.pricing?.totalGross !== undefined)
                        .forEach(attr => attr.pricing.totalNet = this.calculateNet(attr.pricing.totalGross, item.vat));
                    item.extraCharges?.filter(attr => attr.pricing?.totalGross !== undefined)
                        .forEach(attr => attr.pricing.totalNet = this.calculateNet(attr.pricing.totalGross, attr.vat));
                    break;
            }
            this.calculatePricingSummary(item);
        }
        this.recalculatePricing = (item) => {
            if (item.type === 'EXTRA_CHARGE') {
                this.recalculatePricingOfExtraCharge(item);
                return;
            }

            this.recalculatePricingOfAttribute(item)
            switch (item.calculationBasedOn) {
                case 'BASE':
                    delete item.pricing
                    item.pricingBase = this.calculatePricingMethod(item.pricingBase, item.calculationMethod, item.vat, item.livingAreaFinal || item.livingArea)
                    break
                case 'TOTAL':
                    delete item.pricingBase
                    item.pricing = this.calculatePricingMethod(item.pricing, item.calculationMethod, item.vat, item.livingAreaFinal || item.livingArea)
                    break
            }
            this.calculatePricingSummary(item);
        }
        this.calculatePricingMethod = (pricing, calculationMethod, vat, livingArea) => {
            switch (calculationMethod) {
                case "M2":
                    pricing.pricePerOneGross = this.calculateGross(pricing.pricePerOneNet, vat)
                    pricing.totalNet = this.multiplyPerMeters(pricing.pricePerOneNet, livingArea)
                    pricing.totalGross = this.calculateGross(pricing.totalNet, vat)
                    break
                case "M2_GROSS":
                    pricing.pricePerOneNet = this.calculateNet(pricing.pricePerOneGross, vat)
                    pricing.totalGross = this.multiplyPerMeters(pricing.pricePerOneGross, livingArea)
                    pricing.totalNet = this.calculateNet(pricing.totalGross, vat)
                    break
                case "TOTAL":
                    pricing.totalGross = this.calculateGross(pricing.totalNet, vat)
                    delete pricing.pricePerOneNet
                    delete pricing.pricePerOneGross
                    if (livingArea !== undefined) {
                        pricing.pricePerOneNet = this.dividePerMeters(pricing.totalNet, livingArea)
                        pricing.pricePerOneGross = this.calculateGross(pricing.pricePerOneNet, vat)
                    }
                    break
                case "TOTAL_GROSS":
                    pricing.totalNet = this.calculateNet(pricing.totalGross, vat)
                    delete pricing.pricePerOneNet
                    delete pricing.pricePerOneGross
                    if (livingArea !== undefined) {
                        pricing.pricePerOneGross = this.dividePerMeters(pricing.totalGross, livingArea)
                        pricing.pricePerOneNet = this.calculateNet(pricing.pricePerOneGross, vat)
                    }
                    break
            }
            return pricing
        }
        this.calculatePricingSummary = (item) => {
            let attributes_totalNet = item.attributes.map(attr => attr.pricing?.totalNet || 0).reduce((prev, next) => prev + next, 0);
            let attributes_totalGross = item.attributes.map(attr => attr.pricing?.totalGross || 0).reduce((prev, next) => prev + next, 0)

            switch (item.calculationBasedOn) {
                case 'BASE':
                    let pricing_totalNet = item.pricingBase.totalNet + attributes_totalNet
                    let pricing_totalGross = item.pricingBase.totalGross + attributes_totalGross
                    let pricing = {
                        pricePerOneNet: this.dividePerMeters(pricing_totalNet, item.livingAreaFinal || item.livingArea),
                        pricePerOneGross: this.dividePerMeters(pricing_totalGross, item.livingAreaFinal || item.livingArea),
                        totalNet: pricing_totalNet,
                        totalGross: pricing_totalGross
                    }
                    item.pricing = this.calculatePricingMethod(pricing, item.calculationMethod, item.vat, item.livingAreaFinal || item.livingArea)
                    break;
                case 'TOTAL':
                    let base_totalNet = item.pricing.totalNet - attributes_totalNet
                    let base_totalGross = item.pricing.totalGross - attributes_totalGross
                    let pricingBase = {
                        pricePerOneNet: this.dividePerMeters(base_totalNet, item.livingAreaFinal || item.livingArea),
                        pricePerOneGross: this.dividePerMeters(base_totalGross, item.livingAreaFinal || item.livingArea),
                        totalNet: base_totalNet,
                        totalGross: base_totalGross,
                    }
                    item.pricingBase = this.calculatePricingMethod(pricingBase, item.calculationMethod, item.vat, item.livingAreaFinal || item.livingArea)
                    break;
            }
        }
        this.dividePerMeters = (value, area) => {
            return (area && value !== undefined) ? Math.round(value * 100 / area) / 100 : undefined
        }
        this.multiplyPerMeters = (value, area) => {
            return Math.round(value * 100 * area) / 100
        }
        this.sumLivingArea = (items) => {
            return items.map(p => p.property?.livingArea || p.livingArea || 0).reduce((prev, next) => prev + next, 0)
        }
        this.sumLivingAreaWithFinal = (items) => {
            return items.map(p => p.property?.livingAreaFinal || p.livingAreaFinal || p.property?.livingArea || p.livingArea || 0).reduce((prev, next) => prev + next, 0)
        }
        this.sumLivingAreaFinal = (items) => {
            return items.map(p => p.property?.livingAreaFinal || p.livingAreaFinal || 0).reduce((prev, next) => prev + next, 0)
        }
        this.sumBaseTotalNet = (properties) => {
            return properties.map(p => p.pricingBase?.totalNet || 0).reduce((prev, next) => prev + next, 0)
        }
        this.sumBaseTotalGross = (items) => {
            return items.map(p => p.pricingBase?.totalGross || 0).reduce((prev, next) => prev + next, 0)
        }
        this.sumTotalNet = (properties) => {
            return properties.map(p => p.pricing.totalNet).reduce((prev, next) => prev + next, 0)
        }
        this.sumTotalGross = (items) => {
            return items.map(p => p.pricing.totalGross).reduce((prev, next) => prev + next, 0)
        }
        this.calculateGross = (net, vat) => {
            if (net === undefined || vat === undefined)
                return undefined;
            return Math.round(net * 100 * (1 + (vat / 100))) / 100
        }
        this.calculateNet = (gross, vat) => {
            if (gross === undefined || vat === undefined)
                return undefined;
            return Math.round(gross * 100 / (1 + (vat / 100))) / 100
        }
        this.calculateSummary = (properties) => {
            return {
                totalLivingArea: properties.map(p => p.livingArea).reduce((prev, next) => prev + next, 0),
                totalLivingAreaFinal: properties.map(p => p.livingAreaFinal).reduce((prev, next) => prev + next, 0),
                baseTotalNet: this.sumBaseTotalNet(properties),
                baseTotalGross: this.sumBaseTotalGross(properties),
                totalNet: this.sumTotalNet(properties),
                totalGross: this.sumTotalGross(properties),
            }
        }
    })
    .controller('PropertyBatchUploadController', function ($http, toastr, $scope, $rootScope, $uibModalInstance, PropertyService) {
        this.PropertyService = PropertyService;
        this.cancel = () => $uibModalInstance.dismiss('Canceled');
    })
    .controller('PropertySelectController', function ($http, $scope, $rootScope, $uibModalInstance, data, Property, Project, PropertyService) {
        this.reset = () => this.filters = this.primaryFilters
        this.PropertyService = PropertyService;

        this.$onInit = () => {
            this.selected = [];
            this.filters = data;
            this.multiple = data.multiple || false;
            this.alreadySelectedPropertyIds = data.alreadySelectedPropertyIds || [];
            this.primaryFilters = angular.copy(this.filters)
            this.statuses = Property.statuses()
            this.loadProperties()
        }

        this.cancel = () => $uibModalInstance.dismiss('Canceled');

        this.submitMultiple = () => {
            $uibModalInstance.close(this.selected);
        }
        this.select = selected => {
            if(this.multiple){
                if (this.isSelected(selected.id)) {
                    this.selected = this.selected.filter(p => p.id !== selected.id);
                }
                else {
                    this.selected.push(selected);
                }
            }
            else {
                $uibModalInstance.close(selected);
            }
        }
        this.loadProperties = () => {
            let filters = angular.copy(this.filters);
            filters.project = filters.projectId;
            delete filters.projectId;
            delete filters.multiple;

            switch (filters.table) {
                case 'BASIC':
                    delete filters.table;
                    Property.basicTable(filters).$promise.then(result => this.properties = result)
                    break;
                default:
                    Property.table(filters).$promise.then(result => this.properties = result)
                    break;
            }
        }


        this.isAlreadySelected = (id) => {
            return this.alreadySelectedPropertyIds.includes(id);
        }
        this.isSelected = (id) => {
            return this.selected.some(p => p.id === id);
        }
        this.sort = (columnName) => {
            let sort = this.filters.sort || '';
            if(sort === columnName){
                this.filters.sort = columnName + ',desc';
            }
            else {
                this.filters.sort = columnName;
            }
            this.loadProperties();
        }
    })
    .controller('PropertyLockController', function ($http, toastr, $scope, $rootScope, $uibModalInstance, data, Property, PropertyService) {
        this.PropertyService = PropertyService;

        this.$onInit = () => {
            this.item = data;
            if (this.canBeLocked()) {
                this.form = {
                    id: this.item.id,
                    status: 'LOCKED',
                    action: 'lock',
                    notes: this.item.notes
                }
            } else if (this.canBeUnlocked()) {
                this.form = {
                    id: this.item.id,
                    status: 'AVAILABLE',
                    action: 'unlock',
                    notes: this.item.notes
                }
            } else {
                this.cancel();
            }
        }

        this.cancel = () => $uibModalInstance.dismiss('Canceled');
        this.save = () => {
            return Property.action(this.form).$promise.then(result => {
                $rootScope.$broadcast('property.updated', result);
                toastr.success("Zapisano");
                $uibModalInstance.close(result);
            })
        };

        this.canBeLocked = () => {
            return this.item.status === 'AVAILABLE';
        }
        this.canBeUnlocked = () => {
            return this.item.status === 'LOCKED';
        }
        this.isLockable = status => {
            return ['AVAILABLE', 'LOCKED'].contains(status);
        }
    })
    .controller('PropertyDialogController', function ($http, $scope, $rootScope, $uibModalInstance, data, Property, Project, PropertyService) {
        this.item = data;
        this.PropertyService = PropertyService;

        this.$onInit = () => {
            if (this.item.project) {
                this.attributes = Project.attributes({id: this.item.project.id})
                this.buildings = Project.buildings({id: this.item.project.id})
            }
            this.statuses = Property.statuses();
            this.calculationMethods = Property.calculationMethods();
        }

        this.cancel = () => $uibModalInstance.dismiss('Canceled');
        this.save = () => {
            let toSave = angular.copy(this.item);
            if (this.item.id !== null) {
                return Property.update({ id: toSave.id, property: toSave, priceList: this.priceList}, onSaveSuccess, () => {});
            } else {
                return Property.save(toSave, onSaveSuccess, () => {});
            }
        };

        this.addExtraCharge = (projectAttribute) => {
            this.selectedAttribute = undefined;
            if (!projectAttribute)
                return;
            if (this.item.extraCharges?.map(s => s.name).includes(projectAttribute.name))
                return;

            this.item.extraCharges = this.item.extraCharges || [];
            this.item.extraCharges.push({
                name: projectAttribute.name
            })
        }
        this.removeExtraCharge = (idx) => {
            this.item.extraCharges.splice(idx, 1);
            this.PropertyService.recalculatePricing(this.item)
        }

        this.addAttribute = (projectAttribute) => {
            this.selectedAttribute = undefined;
            if (!projectAttribute || this.isAttributeAdded(projectAttribute.name))
                return;

            this.item.attributes.push({
                attribute: projectAttribute.name,
                strategy: projectAttribute.pricingStrategy
            })
        }
        this.isAttributeAdded = (attributeName) => {
            let attributeNames = this.item.attributes.map(s => {
                return s.attribute;
            });
            return attributeNames.includes(attributeName)
        }
        this.removeAttribute = (idx) => {
            this.item.attributes.splice(idx, 1);
            this.PropertyService.recalculatePricing(this.item)
        }

        this.onProjectChanged = () => {
            delete this.item.building;
            this.item.attributes = [];

            if (this.item.project) {
                this.attributes = Project.attributes({id: this.item.project.id})
                this.buildings = Project.buildings({id: this.item.project.id})
            } else {
                this.attributes = [];
                this.buildings = [];
            }
        }

        let onSaveSuccess = result => {
            $rootScope.$broadcast('property.updated');
            $uibModalInstance.close(result);
            toastr.success("Zapisano");
        }
    })
    .component('propertyBtnOptions', {
        bindings: {
            item: '=',
            largeButton: '='
        },
        templateUrl: 'app/property/_btn-options.html',
        controller: function (PropertyService, Principal, FilesSimpleUploadService, FilesLibrary) {
            this.PropertyService = PropertyService;
            this.FilesSimpleUploadService = FilesSimpleUploadService;
            this.FilesLibrary = FilesLibrary;

            this.$onChanges = () => {
                this.fileResourceName = "PROPERTY";
                this.canUploadFiles = Principal.hasAnyAuthority(['ROLE_PROPERTY_FILE_WRITE']);
            }
        }
    })
    .run(function (NavbarLeftMenu) {
        NavbarLeftMenu.add({
            authorities: "ROLE_PROPERTY",
            path: "/property",
            ico: "fa fa-fw fa-building-o",
            name: 'property.menu',
            order: 83
        });
    })
    .config(function ($stateProvider) {
        $stateProvider.state('propertyList', {
            parent: 'app',
            url: '/property?{page:int}&{size:int}&sort&search&type&techTypes&windowSide&status&project&{rooms:int}&{floor:int}&excludeFromStatistics',
            params: {
                techTypes: {array: true},
                status: {array: true, value: ['AVAILABLE', 'LOCKED', 'PRE_BOOKING'], squash: false},
                project: { array: true, type: "int" },
            },
            data: {
                authorities: ['ROLE_PROPERTY']
            },
            views: {
                'content@': 'propertyList'
            },
            resolve: {
                statistics: (Property, $stateParams) => Property.tableStatistics(angular.copy($stateParams)).$promise,
                filters: $stateParams => angular.copy($stateParams),
                page: (Property, $stateParams) => Property.table(angular.copy($stateParams)).$promise
            }
        });
        $stateProvider.state('propertyShow', {
            parent: 'app',
            url: '/property/{id}',
            data: {
                authorities: ['ROLE_PROPERTY']
            },
            views: {
                'content@': {
                    templateUrl: 'app/property/show.html',
                    controller: 'PropertyShowController',
                    controllerAs: '$ctrl'
                }
            },
            resolve: {
                data: (Property, $stateParams) => Property.get({id: $stateParams.id}).$promise,
                $uibModalInstance: $window => ({
                    dismiss: () => $window.history.back()
                })
            }
        });
        $stateProvider.state('propertyStatistics', {
            parent: 'app',
            url: '/property-statistics?{page:int}&{size:int}&sort&search&type&techTypes&windowSide&status&project&{rooms:int}&{floor:int}&excludeFromStatistics',
            params: {
                techTypes: {array: true, squash: false},
                status: {array: true, value: [], squash: false},
                project: { array: true, type: "int" },
                statisticCalculation: { value: 'ACTUAL' }
            },
            data: {
                authorities: ['ROLE_PROPERTY']
            },
            views: {
                'content@': 'propertyStatistics'
            },
            resolve: {
                statistics: (Property, $stateParams) => Property.tableStatistics(angular.copy($stateParams)).$promise,
                filters: $stateParams => angular.copy($stateParams),
                page: (Property, $stateParams) => Property.statistics(angular.copy($stateParams)).$promise
            }
        });
    })
